import { render, staticRenderFns } from "./MakeClientModal.vue?vue&type=template&id=a557bf3e&scoped=true&"
import script from "./MakeClientModal.vue?vue&type=script&lang=js&"
export * from "./MakeClientModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a557bf3e",
  null
  
)

export default component.exports